/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import { fetchData, toasterrormsg } from '../../../../reusable'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40p',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'fs-1'

  var vendor:any=sessionStorage.getItem("vendor");
  vendor=JSON.parse(vendor)
  
const Topbar: FC = () => {

  const [totalUnreactRecords, setTotalUnreadRecords] = useState('0')
  const [isAttributeGet, setIsAttributeGet] = useState(false)
  useEffect(() => {
    const getAttribute = () => {
      const hasAttribute = document.querySelector("body[data-kt-sticky-header='on']");
      if (hasAttribute) {
        setIsAttributeGet(true)
      } else {
        setIsAttributeGet(false)
      }
    }
    window.addEventListener("scroll", getAttribute);
    return () => {
      window.removeEventListener("scroll", getAttribute);
    };
  }, []);

  const statusChangeApiCall = async() => {
    const param = {
      vendorId:String(vendor['vendorId'])
    }
    const response: any = await fetchData('public/notificationRead', param);
    if (response.status == '200') {
      setTotalUnreadRecords('0')
    }else{toasterrormsg(response.message)}
  }
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>

      {/* NOTIFICATIONS */}
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          {/* begin::Menu- wrapper */}
          <div
            className={clsx(
              'btn btn-icon btn-active-light-primary btn-custom',
              toolbarButtonHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
            onClick={statusChangeApiCall}
          >
            <KTIcon iconName='notification-on' iconType='solid' className={`${toolbarButtonIconSizeClass} ${isAttributeGet ? '' : 'text-white'}`} />
            <span className="badge badge-pill badge-danger mt-n5 p-1 ms-n1">{totalUnreactRecords}</span>
          </div>
          <HeaderNotificationsMenu setTotalUnreadRecords={setTotalUnreadRecords} />
          {/* end::Menu wrapper */}
        </div>
        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <img
              className='h-35px w-35px rounded'
              src={vendor && vendor.profile_picture || toAbsoluteUrl('/media/avatars/300-9.jpg')}
              alt='vendor logo'
            />
          </div>
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </div>
  )
}

export {Topbar}
